<div class="container-fluid content-padded small-content">
  <div class="row justify-content-center">
    <div class="form-container">
      <form #contactUs="ngForm" class="col-lg-6 col-md-12 contact-us-form" (ngSubmit)="submitForm()"
            *ngIf="!isSubmitted; else formSubmitted">
        <h1 class="form-title">{{'Contact Us' | translate}}</h1>
        <div class="form-group">
          <label for="name">{{'Name' | translate}}</label>
          <input [disabled]="isSendingForm" type="text" [(ngModel)]="contactUsForm.name" name="contactUsForm.name"
                 class="form-control"
                 id="name" #name="ngModel" required>
          <small [hidden]="name.valid || name.pristine || isSendingForm" class="incorrect-field">
            Name is required
          </small>
        </div>
        <div class="form-group">
          <label for="email">Email</label>
          <input [disabled]="isSendingForm" type="text" [(ngModel)]="contactUsForm.email" name="contactUsForm.email"
                 class="form-control"
                 id="email" #email="ngModel" validateEmail="contactUsForm.email" required>
          <small [hidden]="email.valid || email.pristine || isSendingForm" class="incorrect-field">
            Valid email is required
          </small>
        </div>
        <div class="form-group">
          <label for="message">{{'Message' | translate}}</label>
          <textarea maxlength="3000" [disabled]="isSendingForm" [(ngModel)]="contactUsForm.message"
                    name="contactUsForm.message" class="form-control"
                    id="message" #message="ngModel" required></textarea>
          <small [hidden]="message.valid || message.pristine || isSendingForm" class="incorrect-field">
            Message is required
          </small>
        </div>
        <div class="form-group" *ngIf="captchaSiteKey">
          <re-captcha (captchaExpired)="handleExpiredCaptcha()" (captchaResponse)="handleCorrectCaptcha($event)"
                      language="en" [site_key]="captchaSiteKey"></re-captcha>
        </div>
        <button type="submit" class="btn btn-primary submit" [disabled]="!contactUs.form.valid || !captchaValid">
          {{'Submit' | translate}}
          <i [hidden]="!isSendingForm" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw loading-icon"></i>
        </button>
      </form>
    </div>
    <ng-template #formSubmitted class="col-lg-6 col-md-12">
      <h3 class="greet-title">Thank you for contacting the Cancer Support Community.
        <br>Your feedback is very important to us, and we will contact you within 2 business days.</h3>
      <p class="greet-description">{{'MyCareReport is a support program that does not replace your health care team or medical treatment. Do not make any changes to your treatment routine without first consulting your health care team. If you are experiencing a medical emergency, call 911 or contact your health care team right away.' | translate}}</p>
    </ng-template>
  </div>
</div>
